import { apiClient, PaginatedResponse, QueryParams } from '@/services/apiClient';
import { AddressAdminArea, AddressCountry, AddressLocality } from '@/types';

class AddressService {
  async getCountry(id: string): Promise<AddressCountry> {
    return apiClient.get<AddressCountry>(`/address-countries/${encodeURIComponent(id)}`);
  }

  async getLocality(id: string): Promise<AddressLocality> {
    return apiClient.get<AddressLocality>(`/address-localities/${encodeURIComponent(id)}`);
  }

  async getAdminArea(id: string): Promise<AddressAdminArea> {
    return apiClient.get<AddressAdminArea>(`/address-admin-areas/${encodeURIComponent(id)}`);
  }

  async getCountries(params: QueryParams = {}): Promise<PaginatedResponse<AddressCountry>> {
    return apiClient.getPaginated<AddressCountry>('/address-countries', params);
  }

  async getAdminAreas(params: QueryParams = {}): Promise<PaginatedResponse<AddressAdminArea>> {
    return apiClient.getPaginated<AddressAdminArea>('/address-admin-areas', params);
  }

  async getLocalities(params: QueryParams = {}): Promise<PaginatedResponse<AddressLocality>> {
    return apiClient.getPaginated<AddressLocality>('/address-localities', params);
  }
}

export const addressService = new AddressService();
